import Checkmark from './Checkmark';
import { RadioButtonClassNames } from './constants';
import { RadioButtonFinishedOverlayRoot } from './RadioButton.styled';

type Props = {
  isDisabled: boolean | undefined;
};

const RadioButtonFinishedOverlay: React.FC<Props> = ({
  isDisabled = false,
}) => (
  <RadioButtonFinishedOverlayRoot
    $isDisabled={isDisabled}
    className={RadioButtonClassNames.FinishedOverlay}>
    <Checkmark />
  </RadioButtonFinishedOverlayRoot>
);

export default RadioButtonFinishedOverlay;
